import React, {useEffect, useState} from 'react'
import _ from 'lodash/fp'
import {useToggle, willUseSharedCallback, willUseSharedState} from '@startlibs/core'
import {getFetcher} from '@startlibs/utils'
import {checkForDownload, downloadFile} from 'sharecomponents/src/utils/downloadFile'

export const [useDownloadError, useDownloadErrorRef] = willUseSharedState([])
export const [useAsyncDownloadStore, useAsyncDownloadStoreRef] = willUseSharedState([])
const [useRegisterStarted, callStarted] = willUseSharedCallback()

let ALLOW_REDIRECT = 0
const allowRedirect = () => ALLOW_REDIRECT += 1
export const consumeRedirect = () => {
  if (ALLOW_REDIRECT > 0) {
    ALLOW_REDIRECT -= 1
    return true
  } else {
    return false
  }
}

let downloadQueue = Promise.resolve()
let prepareQueue = Promise.resolve()

const callNextQueue = () => {

}

const addToDownloadQueue = (url) => {
  return downloadQueue = downloadQueue.then(() =>
    new Promise((res) => {
      setTimeout(res, 2000)
    }).then(() => {
      allowRedirect()
      downloadFile(url)
    })
  )
}

const addToPrepareQueue = (url,imageCount) => {
  if (imageCount < 100 ) {
    return getFetcher(url)
      .then((url) => checkForDownload(url))
  } else {
    prepareQueue = prepareQueue.then(() => getFetcher(url))
      .then((url) => checkForDownload(url))
    prepareQueue.catch(() => prepareQueue = new Promise())
    return prepareQueue
  }
}

export const useAsyncDownload = (study, type) => {

  const [, setStoreDownloadError] = useDownloadErrorRef()
  const [asyncStore, setAsyncStore] = useAsyncDownloadStore()

  const [downloadLoading, setDownloadLoading] = useState(asyncStore.find(([{study: {id}}, t]) => id === study.study.id && t === type))
  const [started, setStarted] = useState()
  const [downloadError, setDownloadError] = useState()

  useRegisterStarted(([{study: {id}}, t]) => {
    if (id === study.study.id && type === t) {
      setStarted(true)
      setTimeout(() => setStarted(false), 1500)
    }
  })

  useEffect(() => {
    if (!asyncStore.find(([{study: {id}}, t]) => id === study.study.id && t === type) && downloadLoading) {
      setDownloadLoading(false)
    }
  }, [asyncStore])

  const download = (jwtURL) => () => {
    const item = [study, type]
    setDownloadError(false)
    setAsyncStore(_.concat([item]))
    setDownloadLoading(true)
    return addToPrepareQueue(jwtURL,Number(study.study.imageCount))
      .then(addToDownloadQueue)
      .then(() => {
        setAsyncStore(_.without([item]))
        callStarted(item)
      })
      .catch(() => {
        setDownloadError(true)
        setAsyncStore(_.without([item]))
        setStoreDownloadError(_.concat([[study, download(jwtURL), () => setDownloadError(false)]]))
      })
      .finally(() => setDownloadLoading(false))
  }


  return [download, downloadLoading, started, downloadError]

}